function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  color: #4597e0;\n  font-size: 13px;\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: none;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
export default function ImageUpload(props) {
    var onChange = props.onChange, className = props.className;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(EditButton, {
                className: className,
                htmlFor: "image-input",
                children: "Upload new"
            }),
            /*#__PURE__*/ _jsx(HiddenInput, {
                id: "image-input",
                type: "file",
                onChange: onChange
            })
        ]
    });
}
var EditButton = styled.label(_templateObject());
var HiddenInput = styled.input(_templateObject1());
